var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"singularity-canvas-edit-content-properties-button",on:{"click":_vm.editContentProperties}},[_vm._v("Edit Content Properties")])
}
var staticRenderFns = []

export { render, staticRenderFns }